import React from 'react'
import { Stack, Heading, Text, Flex, FlexProps, Price } from '@thirstycamel/ui'

export interface CartLineProps extends FlexProps {
  label: string
  subLabel?: string
  price?: number
  isFree?: boolean
}

const CartLine = ({ label, subLabel, price, isFree, ...restProps }: CartLineProps) => {
  return (
    <Flex
      direction="row"
      justify="space-between"
      align="center"
      pb={4}
      borderBottom="2px"
      borderColor="gray.200"
      {...restProps}
    >
      <Stack>
        <Heading fontSize="sm" color="gray.500" textTransform="uppercase">
          {label}
        </Heading>

        {subLabel && (
          <Text fontSize="xs" color="gray.500">
            {subLabel}
          </Text>
        )}
      </Stack>

      {isFree ? (
        <Text fontWeight="bold" color="gray.500" fontSize="xl" fontFamily="heading">
          FREE
        </Text>
      ) : (
        <Price
          fontFamily="heading"
          fontSize="2xl"
          fontWeight="bold"
          color="gray.500"
          value={price}
        />
      )}
    </Flex>
  )
}

export default CartLine
